import axios from 'axios';

function defaultApiBaseUrl() {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  if (typeof window !== 'undefined' && window.location.protocol === 'file:') {
    return 'http://127.0.0.1:8000';
  }

  return process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';
}

export const apiBaseUrl = defaultApiBaseUrl();

export const authStorageKey = 'afrihr.auth';

export const api = axios.create({
  baseURL: apiBaseUrl,
});

export function authHeaders(token, params) {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    ...(params ? { params } : {}),
  };
}
